import type { AnalyticsParamValue } from '@sunflower-games/webview-bridge';

/** Keeps entries with a valid key and a value `toValue` maps, up to `max`; earlier keys win the cap. */
export function narrowParams(
  params: Record<string, unknown>,
  isKey: (key: string) => boolean,
  toValue: (value: unknown, key: string) => AnalyticsParamValue | undefined,
  max: number,
): Record<string, AnalyticsParamValue> {
  const narrowed: Record<string, AnalyticsParamValue> = {};
  let count = 0;
  for (const [key, raw] of Object.entries(params)) {
    if (count >= max) break;
    if (!isKey(key)) continue;
    const value = toValue(raw, key);
    if (value === undefined) continue;
    narrowed[key] = value;
    count += 1;
  }
  return narrowed;
}
